import invoke from '../fp/invoke';
/**
 * Utility to dynamically load JS
 * @param {String} url URL of the script to load
 * @param {Boolean} async Indicates whether it should be loaded asynchronously or not
 * @param {Function} callback Function callback to execute once the scrtipt has loaded.
 */
export default function loadScript(url, async = false, callback) {
  const script = document.createElement('script');
  script.type = 'text/javascript';

  if (async) {
    script.async = true;
  }

  if (callback) {
    if (script.readyState) {
      script.onreadystatechange = () => {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          invoke(callback)();
        }
      };
    } else {
      script.onload = () => {
        callback();
      };
    }
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}
